import {
  MIME_TYPE_IMAGE,
  MIME_TYPE_PDF,
  MIME_TYPE_DOC,
  MIME_TYPE_DOCX,
  MIME_TYPE_PPT,
  MIME_TYPE_PPTX,
} from '../defaults/MimeType';

export const validMimeTypes = mimeType => {
  
  if(mimeType.includes('image')) {
    mimeType = 'image/*'
  }
  
  const mimeTypes = {
    [`${MIME_TYPE_IMAGE}`]: () => true,
    [`${MIME_TYPE_PDF}`]: () => true,
    [`${MIME_TYPE_DOC}`]: () => true,
    [`${MIME_TYPE_DOCX}`]: () => true,
    [`${MIME_TYPE_PPT}`]: () => true,
    [`${MIME_TYPE_PPTX}`]: () => true,
    invalid: () => false
  };

  return (mimeTypes[mimeType] || mimeTypes.invalid)();
};

export default validMimeTypes;



// WEBPACK FOOTER //
// ./src/utility/validMimeTypes.js